/* eslint-disable */

import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import Cookies from "js-cookie";
import User from "@/services/User";
import AlertError from "@/store/modules/AlertError";
import Home from "@/store/modules/Home";
import Pengumuman from "@/store/modules/Pengumuman";
import RegistrationData from "@/store/modules/RegistrationData";
import SurveyForm from "@/store/modules/SurveyForm";
import Transaction from "@/store/modules/Transaction";
import SecureLS from "secure-ls";
var ls = new SecureLS({ encodingType: "rc4", isCompression: false });

Vue.use(Vuex);

const user = {
  id: "",
  firstName: "",
  lastName: "",
  username: "",
  email: "",
  role: [
    {
      role_id: 0,
      description: "",
    },
  ],
  whatsappNumber: "",
  urlWhatsappGroup: "",
};

const latest_opened = [
  {
    id: "",
    term: "",
    start_time: "",
    end_time: "",
    category: "",
  },
];

export default new Vuex.Store({
  state: {
    user: user,
    studentTermStatus: 0,
    latest_opened: [
      {
        id: "",
        term: "",
        start_time: "",
        end_time: "",
        category: "",
      },
    ],
    periods: [],
    loading: false,
  },
  getters: {
    isLoading: (state) => {
      return state.loading;
    },
    getRefreshToken: (state) => {
      return Cookies.get("_rId");
    },
    getAccessToken: (state) => {
      return Cookies.get("_aId");
    },
    isUserLoggedIn: (state) => {
      if (Cookies.get("_rId") != null && Cookies.get("_aId") != null) {
        return true;
      }
      return false;
    },
    getFullname: (state) => {
      return state.user.firstName + " " + state.user.lastName;
    },
    getFirstname: (state) => {
      return state.user.firstName;
    },
    getLastname: (state) => {
      return state.user.lastName;
    },
    getUsername: (state) => {
      return state.user.username;
    },
    getUserId: (state) => {
      return state.user.id;
    },
    getUserRole: (state) => {
      return state.user.role;
    },
    getUrlWhatsappGroup: (state) => {
      return state.user.urlWhatsappGroup;
    },
    getTermName: (state) => {
      return state.latest_opened[0].term;
    },
    getPeriodId: (state) => {
      return state.latest_opened[0].id;
    },
    getPeriodStart: (state) => (category) => {
      const period = state.periods.find((data) => data.category == category);
      if (period == undefined) return "";
      return period.start_time;
    },
    getPeriodEnd: (state) => (category) => {
      const period = state.periods.find((data) => data.category == category);
      if (period == undefined) return "";
      return period.end_time;
    },
    getRegistrationPeriodOpened: (state) => {
      const registrationCategory = state.latest_opened.find(
        (data) => data.category == "registration"
      );
      if (registrationCategory != undefined) {
        return true;
      }
      return false;
    },
    getParticipantSelectionPeriodOpened: (state) => {
      const participantSelectionCategory = state.latest_opened.find(
        (data) => data.category == "participant_selection"
      );
      if (participantSelectionCategory != undefined) {
        return true;
      }
      return false;
    },
    getSchedulePeriodOpened: (state) => {
      const scheduleCategory = state.latest_opened.find(
        (data) => data.category == "schedule_choice"
      );
      if (scheduleCategory != undefined) {
        return true;
      }
      return false;
    },
    getPaymentPeriodOpened: (state) => {
      const paymentCategory = state.latest_opened.find(
        (data) => data.category == "payment"
      );
      if (paymentCategory != undefined) {
        return true;
      }
      return false;
    },
    getClassPeriodOpened: (state) => {
      const classCategory = state.latest_opened.find(
        (data) => data.category == "class"
      );
      if (classCategory != undefined) {
        return true;
      }
      return false;
    },
    getReregistrationPeriodOpened: (state) => {
      const reregistrationCategory = state.latest_opened.find(
        (data) => data.category == "re-registration"
      );
      if (reregistrationCategory != undefined) {
        return true;
      }
      return false;
    },
    getReregistrationPeriodData: (state) => {
      return state.reregistrationPeriodData;
    },
    getStudentTermStatus: (state) => {
      return state.studentTermStatus;
    },
  },
  mutations: {
    loadingStart: (state) => {
      state.loading = true;
    },
    loadingEnd: (state) => {
      state.loading = false;
    },
    setRefreshToken: (state, payload) => {
      Cookies.set("_rId", payload.value, { expires: 0.5, secure: false });
    },
    setAccessToken: (state, payload) => {
      Cookies.set("_aId", payload.value, { expires: 0.01, secure: false });
    },
    removeToken: (state) => {
      Cookies.remove("_aId");
      Cookies.remove("_rId");
    },
    removeAccessToken: (state) => {
      Cookies.remove("_aId");
    },
    setUserInfo: (state, payload) => {
      state.user.username = payload.username;
      state.user.id = payload.id;
      state.user.firstName = payload.firstName;
      state.user.lastName = payload.lastName;
      state.user.email = payload.email;
      state.user.whatsappNumber = payload.whatsappNumber;
    },
    setUser: (state, payload) => {
      state.user = payload.user;
    },
    setUserRole: (state, payload) => {
      state.user.role = payload.role;
    },
    setLatestOpened: (state, payload) => {
      state.latest_opened = payload.latest_opened;
    },
    setUrlWhatsappGroup: (state, payload) => {
      state.user.urlWhatsappGroup = payload.value;
    },
    setPeriods: (state, payload) => {
      state.periods = payload.value;
    },
    setStudentTermStatus: (state, payload) => {
      state.studentTermStatus = payload.value;
    },
  },
  actions: {
    RESETUSER: ({ commit }) => {
      commit("setUser", { user: user });
    },
    RESETPERIODDATA: ({ commit }) => {
      commit("setStudentTermStatus", { value: "" });
      commit("setLatestOpened", { latest_opened });
      commit("setPeriods", { value: [] });
    },
    resetAccessToken: async ({ dispatch, getters }) => {
      await User.refreshJWTToken(
        process.env.VUE_APP_URL,
        getters.getRefreshToken
      );
      setTimeout(() => dispatch("resetAccessToken"), 450000);
    },
    RESETSTATE: ({ dispatch }) => {
      dispatch("RESETHOME");
      dispatch("RESETPENGUMUMAN");
      dispatch("RESETALERT");
      dispatch("RESETUSER");
      dispatch("RESETPAYMENT");
      dispatch("RESETREGISTRATIONDATA");
      dispatch("RESETPERIODDATA");
      dispatch("RESETSURVEYFORMSTATE");
    },
  },
  modules: {
    Home,
    Pengumuman,
    RegistrationData,
    AlertError,
    Transaction,
    SurveyForm,
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});
